import _ from 'lodash';

import { SET_LOCALE, TOGGLE_LOCALE } from './IwIntlProvider.actions';
import { mergeStates } from '../iwProvider/StoreHelper';

const initialState = {
    ready: false,
    language: '',
    locale: '',
    currency: ''
};

// eslint-disable-next-line import/no-default-export
export default function intl(state = mergeStates(initialState), action) {
    switch (action.type) {
        case SET_LOCALE:
            return mergeStates(state, {
                ready: true,
                locale: _.get(action, 'data.locale', ''),
                language: _.get(action, 'data.language', ''),
                currency: _.get(action, 'data.currency', '')
            });
        case TOGGLE_LOCALE:
            return mergeStates(state, {
                locale: state.locale === 'en-GB' ? 'de-DE' : 'en-GB',
                language: state.language === 'en' ? 'de' : 'en',
                currency: state.currency === 'GBP' ? 'EUR' : 'GBP'
            });

        default:
            return state;
    }
}
